import { render, staticRenderFns } from "./PhoneThanks.vue?vue&type=template&id=e0cfd0b2&scoped=true&"
import script from "./PhoneThanks.vue?vue&type=script&lang=js&"
export * from "./PhoneThanks.vue?vue&type=script&lang=js&"
import style0 from "./PhoneThanks.vue?vue&type=style&index=0&id=e0cfd0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cfd0b2",
  null
  
)

export default component.exports